import React from 'react';
import { useSelector } from 'react-redux';
import { getMappedValueFromOrderOrItem, truncateWithEllipsis } from '../../../../../../../../util';

import { getOrderingSystem } from '../../../../../../../../selectors/tools';
import { ResultsColumn, CheckBoxColumn, Checkbox, ResultRowOrders } from './DTOrderSearchResult.styles';
import OrderItemsWrapper from './OrderItemsWrapper/OrderItemsWrapper';
import Price from '../../../../../../../common/Price/Price';
import FormattedDate from '../../../../../../../common/FormattedDate/FormattedDate';
import { CurrencyCodeContextProvider } from './CurrencyCodeContext';
import { SHOPIFY } from 'constants/orderingSystems';

const DTOrderSearchResult = (props) => {
  const { order, markAsOrder, isSelected, isLast, onCheckboxClick } = props;

  const orderingSystem = useSelector(getOrderingSystem);
  const currencyCode = getMappedValueFromOrderOrItem(order, 'currency', orderingSystem);
  const totalPrice = getMappedValueFromOrderOrItem(order, 'totalPrice', orderingSystem);
  const fullName = getMappedValueFromOrderOrItem(order, 'fullName', orderingSystem);
  const createdAt = getMappedValueFromOrderOrItem(order, 'createdAt', orderingSystem);
  const orderNumber = getMappedValueFromOrderOrItem(order, 'orderNumber', orderingSystem);
  const riskAssessment = getMappedValueFromOrderOrItem(order, 'riskLevel', orderingSystem);

  const handleCheckboxClick = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      onCheckboxClick(true, order);
    } else {
      onCheckboxClick(false, order);
    }
  };

  return (
    <div>
      <ResultRowOrders checked={isSelected} markAsOrder={markAsOrder}>
        <CheckBoxColumn>
          <Checkbox type="checkbox" checked={isSelected} onChange={handleCheckboxClick} />
        </CheckBoxColumn>
        <ResultsColumn width="25%">
          <span>{orderNumber}</span>
        </ResultsColumn>
        <ResultsColumn width="25%">
          <Price
            value={totalPrice}
            isValueSetInCents={String(orderingSystem) === 'custom_rbi'}
            currencyCode={currencyCode}
          />
        </ResultsColumn>
        <ResultsColumn width="25%">{(fullName && truncateWithEllipsis(fullName, 25)) || '-'}</ResultsColumn>
        <ResultsColumn className="name-column" width="25%">
          <FormattedDate date={createdAt} orderingSystem={orderingSystem} />
        </ResultsColumn>
        {orderingSystem === SHOPIFY && (
          <ResultsColumn width="25%">
            <span>{riskAssessment}</span>
          </ResultsColumn>
        )}
      </ResultRowOrders>
      {isSelected && (
        <CurrencyCodeContextProvider value={currencyCode}>
          <OrderItemsWrapper showLoadingUnderline={isLast} order={order} />
        </CurrencyCodeContextProvider>
      )}
    </div>
  );
};

export default DTOrderSearchResult;
